import { isEmpty } from 'js/utilities/validation';

export const saveAsValidationRules = {
  nextReportName: (data, key) => !isEmpty(data[key]),
  nextFolderId: (data, key) => !isEmpty(data[key]),
  newFolderName: (data, key) => !isEmpty(data[key]),
};
